/**
 * Formats raw user input into a US phone display string: `(999) 999-9999`.
 *
 * Replaces the `react-input-mask` `(999) 999-9999` mask (with empty
 * `maskChar`) which is incompatible with React 19 — it calls the removed
 * `ReactDOM.findDOMNode` and throws on mount in the governed lead drawer.
 * This is a pure, render-version-agnostic, SSR-safe formatter: it strips all
 * non-digits, caps at the 10 significant digits, and re-inserts the literal
 * mask characters progressively as digits are entered (no placeholder chars),
 * matching the prior masked output so stored/submitted values are unchanged.
 */
export function formatPhoneNumber(input: string): string {
  const digits = input.replace(/\D/g, '').slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length < 4) return `(${digits}`;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
